import { Component, OnInit, Input } from "@angular/core";
import { ListDropdownGroupItem } from "./list-dropdown-group-item.model";
import { fadeInOut } from "../../animations";

@Component({
  selector: "common-list-dropdown-group",
  templateUrl: "./list-dropdown-group.component.html",
  styleUrls: ["./list-dropdown-group.component.scss"],
  animations: [fadeInOut("200ms", "0ms")],
})
export class ListDropdownGroupComponent implements OnInit {
  @Input() condensed: boolean = false;
  @Input() listGroupItems: ListDropdownGroupItem[];

  constructor() {}

  ngOnInit() {}
}
